<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <router-link tag="li" :to="{ name: 'gates'}">
              <a>ゲート一覧</a>
            </router-link>
            <li class="active">新規ゲートを登録</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>新規ゲートを登録</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content detail-gate-edit">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
          <div class="alert alert-danger" v-if="errorMessageLogs!==''" v-html="errorMessageLogs"></div>
          <div class="alert alert-success" v-if="message">
            {{ message }}
          </div>
          <div class="row">
            <div class="col-xs-12">
              <!-- PAGE CONTENT BEGINS -->
              <form class="form-horizontal" role="form">
              <div class="row">
              <div class="col-xs-6">
                <div class="row">
                <div class="profile-user-info profile-user-info-striped">
                  <div class="profile-info-row">
                    <div class="profile-info-name">製品ID</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateModelId}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">製品名 <font class="input-required">※必須</font></div>
                    <div class="profile-info-value">
                      <span id="product_error" class="error_m"></span>
                      <select id="productname" class="form-control" data-placeholder="製品名選択" v-model="gateInfor.gateModelId" @change="getGateModelInforWithGateModeId(gateInfor.gateModelId)">
                        <option v-for="(item, index) in listGateModel" v-bind:value="item.gateModelId" v-bind:key="index">
                          {{item.gateModelName}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">型番</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateModelCode}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="gateInfor.customizable && checkShowHide(gateInfor.makerCode, inputIndex.controlTime)">
                    <div class="profile-info-name">ターゲット動作設定Time</div>
                    <div class="profile-info-value">
                      <input type="number" min="0" max="10000" class="form-control input-sm" v-model="gateInfor.controlTime">
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="true">
                    <div class="profile-info-name">ゲート名 <font class="input-required">※必須</font></div>
                    <div class="profile-info-value">
                      <span id="gate_error" v-if="!isGateNameValid" class="error_m">{{gateNameMessage}}</span>
                      <input type="text" v-if="isGateNameValid" class="form-control input-sm" id="gatename" v-model="gateInfor.gateName" @blur="validateBeforeSubmit(1)">
                      <input type="text" v-else class="form-control input-sm error" id="gatename" v-model="gateInfor.gateName" @blur="validateBeforeSubmit(1)">
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.needLocation)">
                    <div class="profile-info-name">位置情報取得</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.needLocation">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.isNFCValid)">
                    <div class="profile-info-name">NFCの有効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isNFCValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.isTenKeyValid)">
                    <div class="profile-info-name">テンキーの有効・無効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isTenKeyValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.isGatePasswordValid)">
                    <div class="profile-info-name">ゲートパスワードの有効・無効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isGatePasswordValid" :disabled="gateInfor.isVisitor" @change="validateBeforeSubmit(2)">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.gatePasswordLength)">
                    <div class="profile-info-name">ゲートパスワードの桁数</div>
                    <div class="profile-info-value">
                      <select class="form-control" v-model="gateInfor.gatePasswordLength" :disabled="getEditStatus()">
                        <option v-for="item in listPassLenght" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.gatePasswordSeed)">
                    <div class="profile-info-name">ゲートパスワードのseed値</div>
                    <div class="profile-info-value">
                      <span id="passwordseed_error" v-if="!isGatePasswordSeedValid" class="error_m">{{gatePasswordSeedMessage}}</span>
                      <input type="text" v-if="isGatePasswordSeedValid" class="form-control input-sm" id="pseed" v-model="gateInfor.gatePasswordSeed" style="text-transform:uppercase" :disabled="getEditStatus()" @blur="validateBeforeSubmit(2)">
                      <input type="text" v-else class="form-control input-sm error" id="pseed" v-model="gateInfor.gatePasswordSeed" style="text-transform:uppercase" :disabled="getEditStatus()" @blur="validateBeforeSubmit(2)">
                    </div>
                  </div>
                </div>
                </div>
              </div>
              <div class="col-xs-6">
                <div class="row">
                  <div class="profile-user-info profile-user-info-striped">
                    <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.isTwoStepAuthValid)"> <!--91-->
                      <div class="profile-info-name">2段階認証の有効・無効</div>
                      <div class="profile-info-value">
                        <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isTwoStepAuthValid" :disabled="gateInfor.isVisitor || disableTwoStepAuth()">
                        <span class="lbl"></span>
                      </div>
                    </div>
                    <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.bleIntensity)"> <!--91-->
                      <div class="profile-info-name">BLE出力設定</div>
                      <div class="profile-info-value">
                        <select class="form-control" v-model="gateInfor.bleIntensity" v-if="gateInfor.makerCode === 2 || gateInfor.makerCode === 4">
                          <option v-for="item in listBleIntensityForWafer" v-bind:value="item.value" v-bind:key="item.value">
                            {{item.text}}
                          </option>
                        </select>
                        <select class="form-control" v-model="gateInfor.bleIntensity" v-else>
                          <option v-for="item in listBleIntensity" v-bind:value="item.value" v-bind:key="item.value">
                            {{item.text}}
                          </option>
                        </select>
                        <p v-if="gateInfor.makerCode === 2 || gateInfor.makerCode === 4" class="note-text">「とても強い」「強い」に設定した場合、電池の消耗が早くなります。</p>
                      </div>
                    </div>
                    <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode,  inputIndex.buzzerPattern)"> <!--91, 2-->
                      <div class="profile-info-name">ブザー鳴動設定</div>
                      <div class="profile-info-value">
                        <select class="form-control" v-model="gateInfor.buzzerPattern">
                          <option v-for="item in listBuzzerPattern" v-bind:value="item.value" v-bind:key="item.value">
                            {{item.text}}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <div class="profile-info-name">備考.1</div>
                      <div class="profile-info-value">
                        <span id="option1_error" class="error_m"></span>
                        <textarea class="form-control" id="option1" placeholder="備考.1" v-model="gateInfor.option1" @blur="validateBeforeSubmit(3)"></textarea>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <div class="profile-info-name">備考.2</div>
                      <div class="profile-info-value">
                        <span id="option2_error" class="error_m"></span>
                        <textarea class="form-control" id="option2" placeholder="備考.2" v-model="gateInfor.option2" @blur="validateBeforeSubmit(4)"></textarea>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <div class="profile-info-name">ステータス</div>
                      <div class="profile-info-value">
                        <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isValid">
                        <span class="lbl"></span>
                      </div>
                    </div>
                    <div class="profile-info-row" v-if="checkShowAnti()">
                      <div class="profile-info-name">アンチパスバックの有効・無効</div>
                      <div class="profile-info-value">
                        <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isAntiPassback" :disabled="disableAntiPass()">
                        <span class="lbl"></span>
                      </div>
                    </div>
                    <div class="profile-info-row" v-if="checkShowAnti()">
                      <div class="profile-info-name">アンチパスバックのモード</div>
                      <div class="profile-info-value">
                        <select id="anti-mode-level" class="form-control" data-placeholder="製品名選択" v-model="gateInfor.antiPassback.mode" v-if="gateInfor.isAntiPassback">
                          <option v-for="item in listAntiMode" v-bind:value="item.value" v-bind:key="item.value">
                            {{item.text}}
                          </option>
                        </select>
                        <select class="form-control" data-placeholder="製品名選択" v-else :disabled="!gateInfor.isAntiPassback">
                          <option></option>
                        </select>
                      </div>
                    </div>
                    <div class="profile-info-row" v-if="checkShowAnti()">
                      <div class="profile-info-name">アンチパスバックの対向ゲート名</div>
                      <div class="profile-info-value">
                        <span id="anti-gate-name-error" class="error_m"></span>
                        <input type="text" class="form-control input-sm" id="anti-gate-name" v-model="gateInfor.antiPassback.gateName" :disabled="true">
                        <button class="btn btn-info save_group_bottom" type="button" @click="showModalAntiGate()" :disabled="disableAntiModes()">
                          対向ゲートの選択
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div class="form-group">
                <div class="col-sm-12 text-align-right">
                  <router-link :to="{ name: 'gates'}" class="btn cancel_bottom">
                    キャンセル
                  </router-link>
                  <button class="btn btn-info save_group_bottom" type="button" @click="editInforGate">
                    保存
                  </button>
                </div>
              </div>
              </form>
              <!-- PAGE CONTENT ENDS -->
            </div><!-- /.col -->
          </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
    <div id="gate-list" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">アンチパスバック対向ゲートの選択</h3>
            <span class="input-icon search-box">
              <input type="text" placeholder="ユーザーID、ユーザー名検索" class="nav-search-input" id="nav-search-input" ref="search_modal" autocomplete="off">
              <i class="ace-icon fa fa-search nav-search-icon"></i>
            </span>
            <button class="btn-cusstom green-btn" type="button" @click="searchGatesForAntipass()">検索</button>
          </div>
          <div class="modal-body">
            <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="listAntiGates != null && listAntiGates.length > 0">
              <thead>
                <tr>
                  <th></th>
                  <th style="width:150px">ゲートID</th>
                  <th>ゲート名</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in listAntiGates.slice(firstItemOfCurrentPage, lastItemOfCurrentPage)" :key="index">
                <tr>
                  <td class="center">
                    <label class="pos-rel">
                      <input type="radio" class="ace" :value="item.gateId" v-model="selectedAntiGateId">
                      <span class="lbl"></span>
                    </label>
                  </td>
                  <td style="max-width:150px;word-wrap: break-word">
                    {{item.gateId}}
                  </td>
                  <td style="max-width:150px;word-wrap: break-word">
                    {{item.gateName}}
                  </td>
                </tr>
              </tbody>
            </table>
            <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
              <thead>
                <tr>
                  <th style="width:150px">ゲートID</th>
                  <th>ゲート名</th>
                </tr>
              </thead>
              <tbody>
                <tr><td colspan="2">データーはありません</td></tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <div class="row pd-t-10">
              <div class="dataTables_paginate paging_simple_numbers" v-if="countPageAntipassGate>0">
                <paginate ref="gates_paginator"
                  :page-count="countPageAntipassGate"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="handleCurrentChange"
                  :prev-text="'<<'"
                  :next-text="'>>'"
                  :container-class="'pagination'"
                  :page-class="'page-item'">
                </paginate>
              </div>
            </div>
            <button class="btn btn-sm btn-danger pull-right" style="width:100px" @click="addAntiGateInfor()" data-dismiss="modal">選択</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'

export default {
  data () {
    return {
      errorMessageLogs: '',
      selectedUserId: [],
      selectedGateId: [],
      listUserGroup: null,
      listGateGroup: null,
      listIconType: [
        { text: 'その他', value: 0 },
        { text: 'ドア', value: 1 },
        { text: 'ロッカー', value: 2 }
      ],
      listIconTypeForVirtualGate: [
        { text: 'その他', value: 0 }
      ],
      listControlTime: [
        { text: '0000－9999 S', value: 0 },
        { text: '000.0-999.9 S', value: 1 },
        { text: '00.00-99.99 S', value: 2 },
        { text: '0.000-9.999 S', value: 3 }
      ],
      listIsVisitor: [
        { text: 'メンバー', value: false }
      ],
      listBuzzerPattern: [
        { text: 'OFF', value: 0 },
        { text: '鳴動パターン１', value: 1 },
        { text: '鳴動パターン２', value: 2 }
      ],
      listPassLenght: [
        { text: '5桁', value: 5 },
        { text: '6桁', value: 6 },
        { text: '7桁', value: 7 },
        { text: '8桁', value: 8 }
      ],
      listBleIntensity: [
        { text: '非常に強い', value: 0 },
        { text: 'とても強い', value: 1 },
        { text: '強い', value: 2 },
        { text: 'やや強い', value: 3 },
        { text: '普通', value: 4 },
        { text: 'やや弱い', value: 5 },
        { text: '弱い', value: 6 },
        { text: 'とても弱い', value: 7 }
      ],
      listBleIntensityForWafer: [
        { text: 'とても強い', value: 1 },
        { text: '強い', value: 2 },
        { text: 'やや強い', value: 3 },
        { text: '普通', value: 4 },
        { text: 'やや弱い', value: 5 },
        { text: '弱い', value: 6 }
      ],
      listAntiMode: [
        { text: 'ログモード', value: 0 },
        { text: '通行禁止モード', value: 1 }
      ],
      listAntiPassGates: null,
      inputIndex: {
        gateName: 1,
        isVisitor: 2,
        isNFCValid: 3,
        isTenKeyValid: 4,
        isGatePasswordValid: 5,
        gatePasswordLength: 6,
        gatePasswordSeed: 7,
        isTwoStepAuthValid: 8,
        bleIntensity: 9,
        buzzerPattern: 10,
        option1: 11,
        option2: 12,
        gateSNMain: 13,
        gateSNBLE: 14,
        gateFWMain: 15,
        gateFWBLE: 16,
        registered: 17,
        updated: 18,
        reported: 19,
        revisionDesired: 20,
        revisionReported: 21,
        voltage: 22,
        scanDate: 23,
        isValid: 24,
        controlTime: 25,
        needLocation: 26
      },
      gateInfor: {
        gateId: '',
        gateModelCode: '',
        gateModelName: '',
        gateModelId: '',
        iconType: 0,
        makerCode: '',
        customizable: false,
        target: 0, // 0: Alligate Logger, 1: Alligate I/O
        controlTime: 0,
        timeUnit: 0,
        gateName: '',
        isVisitor: false,
        isNFCValid: true,
        isTenKeyValid: true,
        isGatePasswordValid: false,
        gatePasswordLength: 5,
        gatePasswordSeed: '',
        isTwoStepAuthValid: false,
        bleIntensity: '', // デフォルトの値は空欄です
        buzzerPattern: 1,
        option1: '',
        option2: '',
        gateSNMain: '',
        gateSNBLE: '',
        gateFWMain: '',
        gateFWBLE: '',
        registered: '',
        updated: '',
        reported: '',
        revisionDesired: '',
        revisionReported: '',
        voltage: '',
        scanDate: '',
        isValid: true,
        needLocation: false,
        isAntiPassback: false,
        antiPassback: {
          gateId: '', // デフォルトの値は空欄です
          gateName: '',
          mode: 0
        }
      },
      gateId: '',
      gateListPages: 2,
      gateListQuery: {
        currPage: 1
      },
      gateListPageSize: 25,
      selectedAntiGateId: '',
      flag: 0,
      message: '',
      isDisabled: false,
      progress: 0,
      success: false,
      loading: false,
      errorMessage: [],
      successUser: 0,
      successGate: 0,
      errorName: '',
      countUser: 0,
      countGate: 0,
      listGateModel: null,
      isEnabledSave: false, // IF true: Enabled button 保存, false: disabled button 保存
      isGatePasswordSeedValid: true,
      gatePasswordSeedMessage: '',
      isGateNameValid: true,
      gateNameMessage: '',
      allOfFieldIsValid: true,
      listAntiGates: [],
      listAntiGatesDefault: [],
      listAntiGatesFilter: [],
      maxAntipassGateRecord: 0,
      totalPagesAntipassGate: 0,
      countPageAntipassGate: 0,
      antiPassGatePageSize: 25,
      currentPageAntiPassGate: 1,
      firstItemOfCurrentPage: 1,
      lastItemOfCurrentPage: 1,
      second: 1,
      interval: 0
    }
  },
  watch: {
    'gateInfor.isVisitor': 'changeValue',
    'gateInfor.isAntiPassback': 'changeIsAntipassback',
    'listAntiGatesDefault': 'bindingListAntiGates',
    'listAntiGates': 'getCountPagesAntiGate',
    'currentPageAntiPassGate': 'getItemIndexOfCurrentPage'
  },
  created () {
    var vm = this
    vm.getListGateModel()
  },
  mounted () {
    var vm = this
    $('#gate-list').on('hidden.bs.modal', this.resetModalGate)
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.searchGatesForAntipass()
      }
    })
  },
  methods: {
    cal () {
      this.second = this.second + 1
    },
    checkShowHide (makerCode, inputIndex) {
      inputIndex = inputIndex || -1
      switch (inputIndex) {
        case this.inputIndex.isTwoStepAuthValid:
          if (makerCode === 91) {
            return false
          } else {
            return true
          }
        case this.inputIndex.bleIntensity:
          if (makerCode === 91) {
            return false
          } else {
            return true
          }
        case this.inputIndex.buzzerPattern:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.isVisitor:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.isNFCValid:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.isTenKeyValid:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.isGatePasswordValid:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.gatePasswordLength:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.gatePasswordSeed:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.controlTime:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.needLocation:
          if (makerCode === 91) {
            return true
          } else {
            return false
          }
        default:
          if (makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
      }
    },
    checkShowAnti () {
      // only show Anti-pass when makercode is ALLIGATE (=1) and is not visitor
      if (!this.gateInfor.isVisitor) {
        if (this.gateInfor.makerCode === 1 && (this.gateInfor.target === 1 || this.gateInfor.target === 5)) {
          // markercode is ALLIGATE and target is ALLIGATE I/O (not Logger)
          return true
        }
        // markercode is not ALLIGATE, it is able to be WaferLock => Anti-pass is resetted (inactive)
        this.resetAntiPassGate()
      }
      return false
    },
    changeIsAntipassback () {
      this.validateBeforeSubmit(4)
    },
    disableAntiPass () {
      // console.log('LOG : disableAntiPass')
      // console.log('LOG : isTwoStepAuthValid', this.gateInfor.isTwoStepAuthValid)
      // this method uses to inactive and disable anti-pass when two-step-auth field is actived
      if (this.gateInfor.isTwoStepAuthValid) {
        // this.resetAntiPassGate()
        this.gateInfor.isAntiPassback = false
        this.gateInfor.antiPassback.gateId = ''
        this.gateInfor.antiPassback.gateName = ''
        this.gateInfor.antiPassback.mode = 0
      }
      return this.gateInfor.isTwoStepAuthValid
    },
    disableTwoStepAuth () {
      // console.log('LOG : disableTwoStepAuth')
      // console.log('LOG : isAntiPassback', this.gateInfor.isAntiPassback)
      // this method uses to inactive and disable two step field when anti-pass is actived
      if (this.gateInfor.isAntiPassback) {
        // if anti-pass is actived then inactive and disable two-step-auth field
        this.gateInfor.isTwoStepAuthValid = false
      }
      return this.gateInfor.isAntiPassback
    },
    disableAntiModes () {
      // console.log('LOG : disableAntiModes')
      // this method uses to check and enable/disable anti modes (level, gate name)
      if (!this.gateInfor.isAntiPassback) {
        // if anti-pass not enable then reset anti modes
        this.gateInfor.antiPassback.gateId = '' // デフォルトの値は空欄です
        this.gateInfor.antiPassback.gateName = '' // デフォルトの値は空欄です
        this.selectedAntiGateId = '' // デフォルトの値は空欄です
      }
      return !this.gateInfor.isAntiPassback
    },
    changeValue () {
      if (this.gateInfor.isVisitor) {
        this.gateInfor.isGatePasswordValid = false
        this.gateInfor.isTwoStepAuthValid = false
        this.resetAntiPassGate()
      }
    },
    getEditStatus () {
      if (!this.gateInfor.isGatePasswordValid || this.gateInfor.isVisitor) {
        return true
      } else {
        return false
      }
    },
    validateBeforeSubmit (index) {
      this.allOfFieldIsValid = true
      if (this.gateInfor.gateModelId === null || this.gateInfor.gateModelId === '') {
        if (index === 0 || index === -1) {
          $('#product_error').html('製品名は必須です。')
          $('#productname').addClass('error')
        }
        this.allOfFieldIsValid = false
      } else {
        if (index === 0 || index === -1) {
          $('#product_error').html('')
          $('#productname').removeClass('error')
        }
      }
      if (this.gateInfor.gateName === null || this.gateInfor.gateName === '') {
        // gate name is required
        if (index === 1 || index === -1) {
          $('#gate_error').html('ゲート名は必須です。')
          $('#gatename').addClass('error')
          this.isGateNameValid = false
          this.gateNameMessage = 'ゲート名は必須です。'
        }
        this.allOfFieldIsValid = false
      } else {
        if (this.gateInfor.gateName.length > 64) {
          // gate Name > 64 chars
          if (index === 1 || index === -1) {
            $('#gate_error').html('ゲート名は64文字以内で入力してください。')
            $('#gatename').addClass('error')
            this.isGateNameValid = false
            this.gateNameMessage = 'ゲート名は64文字以内で入力してください。'
          }
          this.allOfFieldIsValid = false
        } else {
          // reset message
          if (index === 1 || index === -1) {
            $('#gate_error').html('')
            $('#gatename').removeClass('error')
            this.isGateNameValid = true
            this.gateNameMessage = ''
          }
        }
      }
      if (this.gateInfor.isGatePasswordValid && this.gateInfor.gatePasswordSeed.length > 0) {
        var isOk = /^[0-9a-fA-F]+$/.test(this.gateInfor.gatePasswordSeed)
        if (!isOk || this.gateInfor.gatePasswordSeed.length > 18 || this.gateInfor.gatePasswordSeed.length < 18) {
          if (index === 2 || index === -1) {
            $('#passwordseed_error').html('半角英数（0～9、A〜F）で18文字入力してください。')
            $('#pseed').addClass('error')
            this.isGatePasswordSeedValid = false
            this.gatePasswordSeedMessage = '半角英数（0～9、A〜F）で18文字入力してください。'
          }
          this.allOfFieldIsValid = false
        } else {
          if (index === 2 || index === -1) {
            $('#passwordseed_error').html('')
            $('#pseed').removeClass('error')
            this.isGatePasswordSeedValid = true
            this.gatePasswordSeedMessage = ''
          }
        }
      } else {
        if (index === 2 || index === -1) {
          $('#passwordseed_error').html('')
          $('#pseed').removeClass('error')
          this.isGatePasswordSeedValid = true
          this.gatePasswordSeedMessage = ''
        }
      }
      if (this.gateInfor.option1 !== null && this.gateInfor.option1 !== '') {
        if (this.gateInfor.option1.length > 64) {
          if (index === -1 || index === 3) {
            $('#option1_error').html('備考は64文字以内で入力してください。')
            $('#option1').addClass('error')
          }
          this.allOfFieldIsValid = false
        } else {
          if (index === -1 || index === 3) {
            $('#option1_error').html('')
            $('#option1').removeClass('error')
          }
        }
      } else {
        // if option 1 is not input
        if (index === -1 || index === 3) {
          $('#option1_error').html('')
          $('#option1').removeClass('error')
        }
      }
      if (this.gateInfor.option2 !== null && this.gateInfor.option2 !== '') {
        if (this.gateInfor.option2.length > 64) {
          if (index === -1 || index === 4) {
            $('#option2_error').html('備考は64文字以内で入力してください。')
            $('#option2').addClass('error')
          }
          this.allOfFieldIsValid = false
        } else {
          if (index === -1 || index === 4) {
            $('#option2_error').html('')
            $('#option2').removeClass('error')
          }
        }
      } else {
        // if option 2 is not input
        if (index === -1 || index === 4) {
          $('#option2_error').html('')
          $('#option2').removeClass('error')
        }
      }
      if (this.gateInfor.isAntiPassback === true) {
        // anti-pass is actived
        if (this.gateInfor.antiPassback.gateId.trim() === '') {
          if (index === 3 || index === -1) {
            $('#anti-gate-name-error').html('対向ゲートを選択してください')
            $('#anti-gate-name').addClass('error')
          }
          this.allOfFieldIsValid = false
        } else {
          if (index === 3 || index === -1) {
            $('#anti-gate-name-error').html('')
            $('#anti-gate-name').removeClass('error')
          }
        }
      } else {
        if (index === 4 || index === 3 || index === -1) {
          $('#anti-gate-name-error').html('')
          $('#anti-gate-name').removeClass('error')
        }
      }
      this.isEnabledSave = this.allOfFieldIsValid
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD H:mm')
    },
    getListGateModel () {
      this.$http.get(Config.GATE_MODEL_LIST_API)
        .then(response => {
          console.log(response)
          this.listGateModel = response.body.gateModels
        })
        .catch((error) => {
          this.listGateModel = null
          console.log(error)
        })
    },
    getGateModelInforWithGateModeId (gateModelId) {
      var vm = this
      vm.listGateModel.forEach(function (item) {
        if (item.gateModelId === gateModelId) {
          vm.gateInfor.gateModelCode = item.gateModelCode
          vm.gateInfor.gateModelName = item.gateModelName
          vm.gateInfor.controlTime = item.controlTime
          vm.gateInfor.makerCode = item.makerCode
          vm.gateInfor.customizable = item.customizable
          vm.gateInfor.iconType = item.iconType
          vm.gateInfor.target = item.target
          vm.gateInfor.timeUnit = item.timeUnit
          // console.log(item.makerCode)
          if (item.makerCode === 2 || item.makerCode === 4) {
            vm.gateInfor.bleIntensity = 6
          } else {
            vm.gateInfor.bleIntensity = 1
          }
        }
      })
      this.validateBeforeSubmit(0)
    },
    reset () {
      this.gateInfor.gateName = ''
      this.gateInfor.gateModelCode = ''
      this.gateInfor.gateModelId = ''
      this.gateInfor.isVisitor = false
      this.gateInfor.isNFCValid = true
      this.gateInfor.isTenKeyValid = true
      this.gateInfor.isGatePasswordValid = false
      this.gateInfor.isTwoStepAuthValid = false
      this.gateInfor.bleIntensity = '' // デフォルトの値は空欄です
      this.gateInfor.buzzerPattern = 1
      this.gateInfor.isValid = true
      this.gateInfor.gatePasswordSeed = ''
      this.gateInfor.option1 = ''
      this.gateInfor.option2 = ''
      this.gateInfor.makerCode = ''
      this.gateInfor.target = 0
      this.isEnabledSave = false // IF true: Enabled button 保存, false: disabled button 保存
      this.isGateNameValid = true
      this.gateNameMessage = ''
      this.needLocation = true
    },
    editInforGate () {
      this.validateBeforeSubmit(-1)
      if (this.allOfFieldIsValid) {
        var vm = this
        this.message = ''
        this.errorMessageLogs = ''
        vm.loading = true
        const Infor = {
          gateName: vm.gateInfor.gateName,
          gateModelId: vm.gateInfor.gateModelId,
          gateModelName: vm.gateInfor.gateModelName,
          gateModelCode: vm.gateInfor.gateModelCode,
          iconType: vm.gateInfor.iconType,
          makerCode: vm.gateInfor.makerCode,
          customizable: vm.gateInfor.customizable,
          target: vm.gateInfor.target,
          timeUnit: vm.gateInfor.timeUnit,
          controlTime: parseInt(vm.gateInfor.controlTime),
          isVisitor: vm.gateInfor.isVisitor,
          isNFCValid: vm.gateInfor.isNFCValid,
          isTenKeyValid: vm.gateInfor.isTenKeyValid,
          isGatePasswordValid: vm.gateInfor.isGatePasswordValid,
          isTwoStepAuthValid: vm.gateInfor.isTwoStepAuthValid,
          bleIntensity: vm.gateInfor.bleIntensity,
          buzzerPattern: vm.gateInfor.buzzerPattern,
          option1: vm.gateInfor.option1,
          option2: vm.gateInfor.option2,
          isValid: vm.gateInfor.isValid,
          needLocation: vm.gateInfor.needLocation
        }
        if (vm.gateInfor.isGatePasswordValid) {
          Infor.gatePasswordLength = vm.gateInfor.gatePasswordLength
          if (vm.gateInfor.gatePasswordSeed.length > 0) {
            Infor.gatePasswordSeed = vm.gateInfor.gatePasswordSeed
          }
        }
        console.log(Infor)
        this.$http.post(Config.GATES_LIST_API, Infor)
          .then(response => {
            this.reset()
            if (this.gateInfor.isAntiPassback) {
              // anti-pass is actived then create anti-pass for this gate
              var resGateId = response.body.gateId
              this.createAntiPassGate(resGateId)
            } else {
              this.loading = false
              this.message = Config.ADD_GATE_API_SUCCESS
              this.errorMessageLogs = ''
            }
          })
          .catch((error) => {
            this.message = ''
            this.loading = false
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  this.errorMessageLogs = ''
                } else {
                  this.error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                }
                break
              case 400:
                this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.errorMessageLogs = 'ゲートの追加権限がありません。'
                break
              case 409:
                this.errorMessageLogs = '入力されたゲート名は既に使用されています。他のゲート名を入力してください。'
                break
              case 500:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          })
      }
    },
    setDefaultCurPage (curPage) {
      if (this.$refs.gates_paginator) {
        // the selected is started from 0
        this.$refs.gates_paginator.selected = curPage
      }
    },
    resetModalGate () {
      $('#nav-search-input').val('')
      this.listAntiGates = []
      this.listAntiGatesDefault = []
      this.listAntiGatesFilter = []
      this.maxAntipassGateRecord = 0
      this.totalPagesAntipassGate = 0
      this.countPageAntipassGate = 0
      this.antiPassGatePageSize = 25
      this.currentPageAntiPassGate = 1
      this.firstItemOfCurrentPage = 1
      this.lastItemOfCurrentPage = 1
      this.setDefaultCurPage(0)
    },
    showModalAntiGate () {
      // binding textbox anti-pass gate to selected gate
      // this.selectedAntiGateId = this.gateInfor.antiPassback.gateId
      // this.searchGateList()
      this.loadGatesForAntipass()
      $('#gate-list').modal({
        backdrop: 'static',
        keyboard: false
      })
    },
    addAntiGateInfor () {
      var vm = this
      if (this.selectedAntiGateId !== null && this.selectedAntiGateId.trim().length > 0) {
        this.$http.get(Config.GATES_LIST_API + '?gateId=' + encodeURIComponent(this.selectedAntiGateId))
          .then(response => {
            vm.gateInfor.antiPassback.gateId = response.body.gates[0].gateId
            vm.gateInfor.antiPassback.gateName = response.body.gates[0].gateName
            // 3: validate antipass
            vm.validateBeforeSubmit(3)
          })
          .catch(error => {
            console.log(error)
            // 3: validate antipass
            vm.validateBeforeSubmit(3)
          })
      } else {
        // 3: validate antipass
        vm.validateBeforeSubmit(3)
      }
    },
    handleCurrentChange (val) {
      this.currentPageAntiPassGate = val
      // this.getGateList()
    },
    getGateList () {
      this.loading = true
      var keyword = $('#nav-search-input').val()
      keyword = keyword.replace(/\s/g, ',')
      this.$http.get(Config.GATES_LIST_API + '?limit=' + this.gateListPageSize + '&page=' + this.gateListQuery.currPage + '&keyword=' + keyword + '&scorp=gateId,gateName' + '&sortKey=desc:registered&isValid=true')
        .then(response => {
          this.loading = false
          if (response.body.maxRecords > 0) {
            this.gateListPages = Math.ceil((response.body.maxRecords) / this.gateListPageSize)
            this.listAntiPassGates = response.body.gates
          } else {
            this.listAntiPassGates = null
            this.gateListPages = 0
          }
        })
        .catch((error) => {
          this.listAntiPassGates = null
          this.gateListPages = 0
          console.log(error)
        })
    },
    searchGateList () {
      this.loading = true
      var keyword = $('#nav-search-input').val()
      keyword = keyword.replace(/\s/g, ',')
      this.$http.get(Config.GATES_LIST_API + '?limit=' + this.gateListPageSize + '&page=1' + '&keyword=' + keyword + '&scorp=gateId,gateName' + '&sortKey=desc:registered&isValid=true')
        .then(response => {
          this.loading = false
          if (response.body.maxRecords > 0) {
            this.gateListPages = Math.ceil((response.body.maxRecords) / this.gateListPageSize)
            this.listAntiPassGates = response.body.gates
            this.setDefaultCurPage(0)
          } else {
            this.listAntiPassGates = null
            this.gateListPages = 0
          }
        })
        .catch((error) => {
          this.listAntiPassGates = null
          this.gateListPages = 0
          this.loading = false
          console.log(error)
        })
    },
    loadGatesForAntipass () {
      console.log('start:' + this.second)
      this.interval = setInterval(this.cal, 1000)
      this.loading = true
      var pageIndex = 1
      var pageSize = 1000
      // get 1000 first record (page 1)
      this.getGatesForAntipass(pageIndex, pageSize)
    },
    bindingListAntiGates () {
      this.listAntiGates = []
      this.listAntiGates = this.listAntiGatesDefault
    },
    getCountPagesAntiGate () {
      var countAntiGatesInList = this.listAntiGates.length
      this.countPageAntipassGate = Math.ceil(countAntiGatesInList / this.antiPassGatePageSize)
      this.getItemIndexOfCurrentPage()
    },
    getItemIndexOfCurrentPage () {
      this.firstItemOfCurrentPage = (this.currentPageAntiPassGate - 1) * this.antiPassGatePageSize
      this.lastItemOfCurrentPage = (this.firstItemOfCurrentPage + this.antiPassGatePageSize)
    },
    searchGatesForAntipass () {
      var vm = this
      vm.listAntiGates = []
      vm.currentPageAntiPassGate = 1
      this.setDefaultCurPage(0)
      if (vm.listAntiGatesDefault !== null && vm.listAntiGatesDefault.length > 0) {
        var keyword = $('#nav-search-input').val()
        // keyword = keyword.replace(/\s/g, '')
        if (keyword !== null && keyword.trim().length > 0) {
          vm.listAntiGatesDefault.forEach(function (item) {
            if (item.gateId.indexOf(keyword) !== -1 ||
                item.gateName.indexOf(keyword) !== -1 ||
                item.gateId === keyword ||
                item.gateName === keyword) {
              vm.listAntiGates.push(item)
            }
          })
          console.log(vm.listAntiGates)
        } else {
          vm.listAntiGates = vm.listAntiGatesDefault
        }
      }
    },
    getGatesForAntipass (pageIndex, pageSize) {
      var vm = this
      this.$http.get(Config.GATES_LIST_API + '?limit=' + pageSize + '&page=' + pageIndex + '&keyword=' + '&scorp=gateId,gateName' + '&sortKey=desc:registered&isValid=true')
        .then(response => {
          vm.maxAntipassGateRecord = response.body.maxRecords
          if (vm.maxAntipassGateRecord > 0) {
            response.body.gates.forEach(function (item) {
              if (item.isAntiPassback === false &&
                  item.makerCode === 1 && (item.target === 1 || item.target === 5) && !item.isVisitor && !item.isTwoStepAuthValid) {
                vm.listAntiGatesDefault.push(item)
              }
            })
            if (pageIndex === 1) {
              // set current page is 0 (page 1)
              this.setDefaultCurPage(0)
            }
            // calculate total page of all records (all records are returned from API)
            vm.totalPagesAntipassGate = Math.ceil((vm.maxAntipassGateRecord) / pageSize)
            if (vm.totalPagesAntipassGate > pageIndex) {
              // continue get gates from API (get more 1000 next record)
              vm.getGatesForAntipass(pageIndex + 1, pageSize)
            } else if (vm.totalPagesAntipassGate === pageIndex) {
              // the current page is the last page
              this.loading = false
              clearInterval(this.interval)
              console.log('end:' + this.second)
            }
          } else {
            this.loading = false
            clearInterval(this.interval)
            console.log('end:' + this.second)
          }
        })
        .catch((error) => {
          if (vm.totalPagesAntipassGate === pageIndex) {
            // the current page is the last page
            this.loading = false
          }
          console.log(error)
        })
    },
    resetAntiPassGate () {
      this.gateInfor.isAntiPassback = false
      this.gateInfor.antiPassback = {
        gateId: '', // デフォルトの値は空欄です
        gateName: '',
        mode: 0
      }
    },
    createAntiPassGate (gateId) {
      var vm = this
      this.errorMessageLogs = ''
      const Infor = {
        ownerId: localStorage.ownerId,
        gateIdA: gateId,
        gateIdB: vm.gateInfor.antiPassback.gateId,
        mode: vm.gateInfor.antiPassback.mode
      }
      console.log(Infor)
      this.$http.post(Config.RELATION_ANTIPASS_GATE_API, Infor)
        .then(response => {
          this.resetAntiPassGate()
          this.loading = false
          this.message = Config.ADD_GATE_API_SUCCESS
          this.errorMessageLogs = ''
        })
        .catch((error) => {
          this.resetAntiPassGate()
          this.message = ''
          this.loading = false
          this.errorMessageLogs = 'ゲートの新規登録は完了しました。アンチパスバックの登録に失敗しました。<br>ゲート編集より、再度アンチパスバックの変更をお願いします。'
          console.log(error)
        })
    }
  }
}
</script>
<style>
.note-text{
  margin: 10px 0px 0px
}
.detail-gate-edit .profile-info-name{
  width: 400px
}
.float-left{
    float: left;
    padding-left: 12px
  }
  .btn-cus{
    padding: 10px 15px;
    color: #fff
  }
  .btn-right{
    float: right;
  }
  .btn-add,.btn-add:hover{
    background: #007F41!important
  }
  a.btn-delete,a.btn-delete:hover{
    background: #000!important;
    border-color: #000!important;
    color: #fff!important;
    margin-right: 10px;
    text-decoration: none;
  }
  .form-horizontal .control-label{
    margin-top: 0px
  }
  .col-custom{
    padding-right: 0px!important;
  }
  .iValid{
    padding-top: 2px!important;
  }
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .message{
    position: absolute;
  }
  .form-horizontal .control-label{
    text-align: left;
  }
  #gate-list .modal-body {
    height: 250px;
    overflow-y: auto;
  }
  #gate-list .modal-content {
    width: 768px;
    overflow-y: auto;
  }
  #gate-list .modal-header h3.frofile-title{
    padding-bottom: 10px
  }
  #gate-list .modal-header {
    padding: 10px 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/gate/GateAdd.vue